export default {
    "SETTINGS": {
        "target": "Cél dátum",
        "ad_url": "Középső csempe cél",
        "contact_email": "Form email cím",
        "main_page_text": "Fő oldal szöveg HU",
        "main_page_text_hu": "Fő oldal szöveg HU",
        "main_page_text_en": "Fő oldal szöveg EN",
        "main_page_image": "Fő oldal háttérkép",
        "form_fazekas": "Űrlap: Fazekastalálkozó",
        "form_vendeglatos": "Űrlap: Vendéglátósok",
        "form_maganudvar": "Űrlap: Magánudvar",
        "form_malomudvar": "Űrlap: Malomsziget",
        "form_kastelyudvar": "Űrlap: Malomsziget",
        "form_zenekar": "Űrlap: Fellépők",
        'form_egyeb': 'Űrlap: Egyéb',
        "gallery_intro_en": "Galléria intró EN",
        "gallery_intro_hu": "Galléria intró HU",
        "main_page_programs_link": "Program szekció link",
        "main_page_link": "Fő kép Link",
        "main_page_logo": "Logo HU",
        "main_page_logo_hu": "Logo HU",
        "main_page_logo_en": "Logo EN",
        "main_page_counter_en": "Fő oldal visszaszámláló szöveg EN",
        "main_page_counter_hu": "Fő oldal visszaszámláló szöveg HU",
        "main_page_categories_header_hu": "Fő oldal kategóriák cím HU",
        "main_page_categories_header_en": "Fő oldal kategóriák cím EN",
        "app_url_android": "App Url Android",
        "app_url_ios": "App Url iOS",
        'main_page_youtube_embed': 'Aftermovie',
        'main_page_galleries_header_hu': 'Galléria cím HU',
        'main_page_galleries_header_en': 'Galléria cím EN',
        'main_page_tickets_header_hu': 'Jegyek cím HU',
        'main_page_tickets_header_en': 'Jegyek cím EN',
        'page_title_hu': 'Oldal cím HU',
        'page_title_en': 'Oldal cím EN',
        'page_description_hu': 'Oldal leírás HU',
        'page_description_en': 'Oldal leírás EN',
        'date_from': 'Kezdődátum',
        'date_to': 'Végedátum',
        'social_instagram': 'Instagram link',
        'social_facebook': 'Facebook link',
        'social_youtube': 'Youtube link',
        'social_spotify': 'Spotify link',
        'webshop_title_hu': 'Webshop cím HU',
        'webshop_title_en': 'Webshop cím EN',
        'webshop_description_hu': 'Webshop leírás HU',
        'webshop_description_en': 'Webshop leírás EN',
        'webshop_link_text_hu': 'Webshop Link Szöveg HU',
        'webshop_link_text_en': 'Webshop Link Szöveg EN',
        'webshop_link': 'Webshop Link',
        'main_page_ticket_button_hu': 'Jegyvásárlás gomb szöveg HU',
        'main_page_ticket_button_en': 'Jegyvásárlás gomb szöveg EN',
        'main_page_programs_button_hu': 'Programok gomb szöveg HU',
        'main_page_programs_button_en': 'Programok gomb szöveg EN',
        'webshop_image': 'Webshop kép',
        'egesz-napos-programok-image': 'Egész napos programok mobil kép',
        'most-szinpadon-image': 'Mosz színpadon mobil kép',
        'footer_follow_hu': 'Footer kövess minket HU',
        'footer_follow_en': 'Footer kövess minket EN',
        'page_subdescription_hu': 'Oldal alcím HU',
        'page_subdescription_en': 'Oldal alcím EN',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/settings.js